export const updateCompany = (payload = {}) => ({
  type: 'UPDATE_COMPANY',
  payload
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/CompanyActions/index.js